import { defineComponent as _defineComponent } from 'vue'
import useAvailabilityState from '@/state/availabilityState';
import useAvailability from '@/mixins/useAvailability';
import BCXChevronSwitch from '@/components/molecules/BCXChevronSwitch.vue';
import { computed } from 'vue';
import useI18n from '@/mixins/useI18n';
import useResponsiveness from '@/mixins/useResponsiveness';


export default /*#__PURE__*/_defineComponent({
  __name: 'NewAvailabilityHeader',
  props: {
  forceDot: Boolean
},
  setup(__props) {



const { t } = useI18n();

const { availability, isAvailabilityPanelOpen } = useAvailabilityState();
const { whenToolbar, isAvailable } = useAvailability(availability);

const { isAvailabilityTabletWidth } = useResponsiveness();

const availabilityTitle = computed(() => {
  if (isAvailabilityTabletWidth.value) {
    return isAvailable.value ? t('availability.available') : t('availability.unavailable');
  }
  return `${t('availability.title')}:`;
});


return { __sfc: true,t, availability, isAvailabilityPanelOpen, whenToolbar, isAvailable, isAvailabilityTabletWidth, availabilityTitle, BCXChevronSwitch }
}

})